import { vars } from "@frontend/styles/contract.css";

export const LOADER_TAG_NAME = "loader" as const;

export const LOADER_VARIANTS = ["bar", "dots"] as const;

type FontSize = keyof typeof vars.font.size;

export const LOADER_SIZES = Object.keys(vars.font.size) as [
  FontSize,
  ...FontSize[],
];
